export default "__VITE_ASSET__pEb4yIQG__"